import { render, staticRenderFns } from "./GroupBuyingDetails.vue?vue&type=template&id=34f997d3&scoped=true&"
import script from "./GroupBuyingDetails.vue?vue&type=script&lang=js&"
export * from "./GroupBuyingDetails.vue?vue&type=script&lang=js&"
import style0 from "./GroupBuyingDetails.vue?vue&type=style&index=0&id=34f997d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f997d3",
  null
  
)

export default component.exports